import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f7648d38&scoped=true&"
import script from "./js/app.js?vue&type=script&lang=js&"
export * from "./js/app.js?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=f7648d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7648d38",
  null
  
)

export default component.exports